export const AppConfig = {
  AppName: import.meta.env.REACT_APP_NAME,
  Stage: import.meta.env.REACT_APP_STAGE,
  ApiDomain: import.meta.env.REACT_APP_DOMAIN,
  Version: import.meta.env.REACT_APP_VERSION,
} as const
